import React from "react";

export default class PaymentsDropdown extends React.Component {
  state = {
    listVisible: false
  };
  select = item => {
    if (item) {
      const { onSelectItem } = this.props;
      onSelectItem(item);
    }
  };

  show = () => {
    this.setState({ listVisible: true });
    document.addEventListener("click", this.hide);
  };

  hide = () => {
    this.setState({ listVisible: false });
    document.removeEventListener("click", this.hide);
  };

  renderListItems = () => {
    const { payments, onClickNewCard } = this.props;

    return [
      ...payments.map((listItem, index) => {
        return (
          <div
            key={index}
            className="p-15"
            onClick={() => this.select(listItem)}
          >
            <div className="d-flex align-items-center flex-grow-1">
              <img
                src={`/svg/payment/${listItem.method.toLowerCase()}.svg`}
                className="mr-1"
              />
              <span>**** **** **** {listItem.last4}</span>
            </div>
          </div>
        );
      }),
      <div key={9999} onClick={onClickNewCard}>
        <span>+ Add new card</span>
      </div>
    ];
  };
  render() {
    const { selectedPayment } = this.props;
    const { listVisible } = this.state;
    return (
      <div className={"dropdown-container" + (listVisible ? " show" : "")}>
        <div
          className={"dropdown-display" + (listVisible ? " clicked" : "")}
          onClick={this.show}
        >
          {selectedPayment && (
            <div className="d-flex align-items-center flex-grow-1">
              <img
                src={`/svg/payment/${selectedPayment.method.toLowerCase()}.svg`}
                className="mr-1"
              />
              <span>**** **** **** {selectedPayment.last4}</span>
            </div>
          )}

          <i className="icon icon-arrow-3 open" />
        </div>
        <div className="dropdown-list">
          <div>{this.renderListItems()}</div>
        </div>
      </div>
    );
  }
}
